import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Zap, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const STORAGE_KEY = 'sendpi_nudge_dismissed';
const SHOW_DELAY_MS = 12000; // Show after 12 seconds on site

export function SignupNudge() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Don't show if already dismissed, or user is logged in, or on auth pages
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (dismissed) return;

    const path = window.location.pathname;
    if (['/login', '/signup', '/dashboard', '/admin', '/support'].some(p => path.startsWith(p))) return;

    // Check if user already has auth cookie
    if (document.cookie.includes('access_token') || document.cookie.includes('admin_token')) return;

    const timer = setTimeout(() => setShow(true), SHOW_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    setShow(false);
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-24 right-6 z-[80] max-w-sm animate-in slide-in-from-right-5 fade-in duration-500" data-testid="signup-nudge">
      <div className="relative bg-[#0E1830]/95 backdrop-blur-xl border border-[#8B5CF6]/20 rounded-2xl p-5 shadow-[0_8px_32px_rgba(0,0,0,0.4)]">
        <button
          onClick={dismiss}
          className="absolute top-3 right-3 text-white/20 hover:text-white/50 transition-colors"
          data-testid="nudge-close"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="flex items-start gap-3 mb-3">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-[#8B5CF6] to-[#06B6D4] flex items-center justify-center shrink-0">
            <Zap className="w-4 h-4 text-white" />
          </div>
          <div>
            <h3 className="text-white font-space font-bold text-sm">Get 200 free credits</h3>
            <p className="text-white/40 text-xs mt-0.5">No credit card required</p>
          </div>
        </div>

        <p className="text-white/50 text-xs leading-relaxed mb-4">
          Sign up in 10 seconds and unlock PI Check, PI Craft, Token Optimizer, and access to 4.3M precision casts.
        </p>

        <div className="flex gap-2">
          <Link to="/signup" onClick={dismiss} className="flex-1">
            <Button className="w-full shimmer-btn text-white rounded-full text-xs font-bold py-2.5 border-0" data-testid="nudge-signup">
              Sign Up Free <ArrowRight className="w-3 h-3 ml-1.5" />
            </Button>
          </Link>
          <button onClick={dismiss} className="px-3 py-2 text-white/30 text-xs hover:text-white/50 transition-colors">
            Later
          </button>
        </div>
      </div>
    </div>
  );
}
